<template>
  <div class="wrapper">
    <v-header class="header"></v-header>
    <router-view class="main-container" v-slot="{ Component }">
      <transition appear name="fade">
        <component :is="Component"></component>
      </transition>
    </router-view>
  </div>
</template>
<script>
import { defineAsyncComponent, watch } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { getAmount } from '@/utils/amount';

export default {
  name: 'wrapper',
  components: {
    VHeader: defineAsyncComponent(() => import('@/components/common/VHeader.vue')),
  },
  setup() {
    //存資料給客顯螢幕用
    const getCart = useGetters('cart', ['getCart']);
    const { getTransaction, getTax } = useGetters('checkout', ['getTransaction', 'getTax']);
    const getWantCardNo = useGetters('member', ['getWantCardNo']);
    const { computePaid, change } = getAmount();
    const doPushInfoForGuest = useActions('order', ['doPushInfoForGuest']);
    watch(
      () => [getCart.value, getTransaction.value, computePaid.value, change.value, getTax.value, getWantCardNo.value],
      () => {
        const data = {
          cart: getCart.value,
          total: getTransaction.value?.total || 0,
          quantity: getTransaction.value?.quantity || 0,
          paid: computePaid.value || 0,
          change: change.value || 0,
          tax: getTax.value || '',
          want_card: getWantCardNo.value,
        };
        doPushInfoForGuest({ type: 'update_order', data });
      },
      { immediate: true }
    );
  },
};
</script>
